"use client"

import { ScopeProvider } from "bunshi/react"
import { NftsToSellScopeReatom } from "./scope.reatom"

interface Props {
  children: React.ReactNode
}

export function NftsToSellScopeProvider({ children }: Props) {
  return (
    <ScopeProvider scope={NftsToSellScopeReatom} value={[]}>
      {children}
    </ScopeProvider>
  )
}
